import { Securite } from '../../domain/securite';
import { mapper } from '../../tools/mapping/mapper';
import { SecuriteEntity } from '../entity';
import type { AppDB } from '../db';

export class SecuriteRepository {
    constructor(private readonly database: AppDB) {}


    async getSecuriteEntityById(id: number) {
        return await this.database.securites.where('Id').equals(id).first(async se => {
            return se;
        });
    }

    async attachSecuriteToZone(securite: Securite, isPose: boolean, zoneMeasureId: number) {
        let securiteId: number;
        const se = mapper.map(securite, Securite, SecuriteEntity);
        se.IsPose = isPose;

        securiteId = await this.database.securites.add(se);
        await this.database.mesures.update(zoneMeasureId, isPose ? {
            PoseSecuriteId: securiteId
        } : {
            DePoseSecuriteId: securiteId
        });
        return securiteId;

    }

    async attachSecuriteToProcess(securite: Securite, processMeasureId: number) {
        let securiteId: number;
        const se = mapper.map(securite, Securite, SecuriteEntity);
        se.IsPose = true;

        securiteId = await this.database.securites.add(se);
        await this.database.processMeasures.update(processMeasureId, {
            SecuriteId: securiteId
        });

        return securiteId;
    }
}
